"use client"

import React from "react"

function pretty(ts) {
  try { return new Date(ts).toLocaleString() } catch { return String(ts) }
}

export default function RunBreadcrumb({
  datasetLabel,
  runs,
  selectedRunId,
  onSelectRun,
  onBackToLatest,
  className = "",
}) {
  const current = runs.find(r => r.id === selectedRunId) || runs[0] || null

  return (
    <div
      className={[
        "sticky top-12 z-30 w-full",
        "bg-white/70 dark:bg-gray-900/70 backdrop-blur",
        "border-b border-gray-200 dark:border-gray-800",
        "px-4 py-2",
        className
      ].join(" ")}
    >
      <div className="max-w-7xl mx-auto flex items-center gap-3 text-sm">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
          <span className="font-medium text-gray-800 dark:text-gray-100">Dataset:</span>
          <span className="px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-800">
            {datasetLabel}
          </span>

            <span className="text-gray-400">/</span>

          <span className="font-medium text-gray-800 dark:text-gray-100">Run:</span>
          <div className="relative">
            <select
              className="appearance-none pr-8 pl-2 h-7 rounded border border-gray-300 dark:border-gray-700
                         bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100"
              value={selectedRunId || (runs[0]?.id ?? "")}
              onChange={(e) => onSelectRun(e.target.value)}
            >
              {runs.length === 0 ? (
                <option value="">No runs</option>
              ) : (
                runs.map((r, i) => (
                  <option key={r.id} value={r.id}>
                    #{runs.length - i} • {pretty(r.ts)}
                  </option>
                ))
              )}
            </select>
            <svg
              className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
              viewBox="0 0 20 20" fill="currentColor"
            >
              <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
            </svg>
          </div>

          {current && (
            <>
              <span className="text-gray-400">/</span>
              <span className="text-gray-600 dark:text-gray-300">
                {current.summary?.nodeTypes ?? 0} node types • {current.summary?.edges ?? 0} edges
              </span>
            </>
          )}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <button
            onClick={onBackToLatest}
            className="h-8 px-3 rounded border border-gray-300 dark:border-gray-700
                       bg-white hover:bg-gray-50 text-gray-800
                       dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700"
          >
            Back to latest
          </button>
        </div>
      </div>
    </div>
  )
}
